export const savedMessagesRoute = '/employer/saved-messages/';
export const savedEnterpriseMessagesRoute = '/enterprise/saved-messages/';
export const enterpriseSavedMessagesRoute = '/enterprise/saved-messages/';
export const enterpriseCompaniesGet = '/enterprise/company/get';
